var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({attrs:{"small":"","text":""}},_vm.$listeners),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-table")]),_vm._v(" "+_vm._s(_vm.$t("widgets.common.showTable"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }